import js from './javascript-vertical.svg';
import react from './reactjs-icon.svg';
import spring from './springio-icon.svg';
import java from './java-icon.svg';
import idea from './innovation.svg';
import twitter from './twitter-official.svg';
import git from './github-tile.svg';
import notfound from './not-found.svg';
import cross from './cross-svgrepo-com.svg';

export { js, react, spring, java, idea, twitter, git, notfound, cross };
